import { Theme } from "./theme";

export const darkTheme: Theme = {
    primaryBackground: '#1a1a1a',
    primaryBorder: '#333333',
    primaryForeground: 'white',
    primaryText: 'white',
    primaryColor: '#1976D2',
    secondaryText: '#a0a0a0',
    reviewCardBackground: '#2d2d2d',
    secondaryBackground: '#2d2d2d',
    secondaryBorder: '#404040',
    secondaryIcon: '#a0a0a0',
    successButtonBackground: '#388E3C',
    successButtonForeground: 'white',
    successButtonBorder: '#1B5E20',
    failButtonBackground: '#D32F2F',
    failButtonForeground: 'white',
    failButtonBorder: '#B71C1C',
    neutralButtonBackground: '#424242',
    neutralButtonForeground: 'white',
    neutralButtonBorder: '#212121',
    cardShadow: '#121212',
    floatingButtonBackground: '#424242',
    floatingButtonShadow: 'RGBA(18,18,18,0.5)',
    inputBackground: '#2d2d2d',
    inputBorder: '#404040',
    inputText: 'white',
    accentColor: '#1976D2',
    dangerColor: '#f44336',
    dangerColorHover: '#d32f2f',
    successColor: '#4caf50',
    successColorHover: '#45a049',
    overlayBackground: 'rgba(0, 0, 0, 0.5)',
    hoverBackground: '#3d3d3d',
    buttonText: 'white',
    error: '#f44336',
    accentColorDark: '#0d47a1',
}
